var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Styles from './switch-kv-styles.scss';
import React from 'react';
const SwitchKVBase = (_a) => {
    var { testId, text = 'Switch', disabled = false, setChecked, checked = false } = _a, props = __rest(_a, ["testId", "text", "disabled", "setChecked", "checked"]);
    const handleChange = (e) => {
        setChecked(e.target.checked);
    };
    return (React.createElement("div", { className: Styles.switchWrap },
        text && React.createElement("span", { className: Styles.switchText }, text),
        React.createElement("label", { className: Styles.switch },
            React.createElement("input", { type: "checkbox", "data-testid": testId, disabled: disabled, checked: checked, onChange: handleChange }),
            React.createElement("span", { className: Styles.slider }))));
};
export default SwitchKVBase;
